export default "data:text/less;base64,QGJhc2VXaWR0aDogMTIwMHB4OwpAY29udGVudE1pbldpZHRoOiA1NzBweDsKQGJsYWNrOiAjMDAwOwpAd2hpdGU6ICNmZmY7Cg=="